class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const options = { rootMargin: "0px", threshold: 1.0 };
    const observer = new IntersectionObserver(this.toggleDisplay, options);
    const target = document.querySelector(".product-form__buttons");

    observer.observe(target);
  }

  toggleDisplay(entries) {
    const stickyBar = document.querySelector('sticky-add-to-cart');

    if (stickyBar) {
      entries.forEach(entry => {
        !entry.isIntersecting
          ? stickyBar.classList.add('is-active')
          : stickyBar.classList.remove('is-active');
      });
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);